<template>
    <div class="py-4">
        <h4 class="text-center font-active">Shop Fine {{ $t('jewelry') }}</h4>
        <div class="row mt-4 pt-3">
            <div class="col-md-3 col-6 text-center">
                    <NuxtLink :to="localePath({ name: 'shop-earring'})">
                        <picture>
                        <source width="278" height="278" type="image/webp" srcset="assets/landing/jewelry/shop/stud.webp">
                        <img class="radious_eight" loading="lazy" alt="Stud Earrings" width="278" height="278" src="assets/landing/jewelry/shop/stud.jpg" >
                        </picture>
                        <span>Stud Earrings</span>
                    </NuxtLink>
            </div>
            <div class="col-md-3 col-6 text-center">
                    <NuxtLink :to="localePath({ name: 'shop-bracelet'})">
                        <picture>
                        <source width="278" height="278" type="image/webp" srcset="assets/landing/jewelry/shop/eternity.webp">
                        <img class="radious_eight" loading="lazy" alt="Tennis Bracelets" width="278" height="278" type="image/jpeg" src="assets/landing/jewelry/shop/eternity.jpg">
                        </picture>
                        <span>Tennis Bracelets</span>
                    </NuxtLink>
            </div>
            <div class="col-md-3 col-6 text-center">
                    <NuxtLink :to="localePath({ name: 'shop-eternity'})">
                        <picture>
                        <source width="278" height="278" type="image/webp" srcset="assets/landing/jewelry/shop/tennis.webp">
                        <img class="radious_eight" loading="lazy" alt="Eternity Rings" width="278" height="278" type="image/jpeg" src="assets/landing/jewelry/shop/tennis.jpg">
                        </picture>
                        <span>Eternity Rings </span>
                    </NuxtLink> 
            </div>
            <div class="col-md-3 col-6 text-center">
                    <NuxtLink :to="localePath({ name: 'shop-tennis-necklace'})">
                        <picture>
                        <source width="278" height="278" type="image/webp" srcset="assets/landing/jewelry/shop/necklase.webp">
                        <img class="radious_eight" loading="lazy" alt="Tennis Necklaces" width="278" height="278" type="image/jpeg" src="assets/landing/jewelry/shop/necklase.jpg">
                        </picture>
                        <span>Tennis Necklaces</span>
                    </NuxtLink>
            </div>
        </div>
    </div>
</template>



<script setup>
     const localePath = useLocalePath()
</script>

<style scoped>
    h4{
        font-size: 32px;
        text-transform: capitalize;
    }
    a{
        color: #000;
        display: inline-block;
    } 
    span{
        display: block;
        text-align: center;
        font-size: 16px;
        padding-top: 4%;
        font-weight: 400;
    }
    @media(max-width: 992px){
        h4{
            font-size: 24px;
        }
    }
    @media(max-width: 767px){
    
        a{
            margin-bottom: 12%;
        }
    }
</style>
